<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" lg="12">
      <b-card no-header style="min-height:60vh;">
        <template slot="header">Change Password</template>
        <b-row class="justify-content-center">
          <b-col cols="12" md="6">
            <span style="font-size:16px;font-weight:500;color:red;">{{msg}}</span>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col cols="12" md="6">
            <b-form-group>
              <label for="name">Old Password</label>
              <b-form-input
                v-model="oldPassword"
                type="text"
                id="oldPassword"
                placeholder="●●●●●●●●"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col cols="12" md="6">
            <b-form-group>
              <label for="name">New Password</label>
              <b-form-input
                v-model="newPassword"
                type="text"
                id="newPassword"
                placeholder="●●●●●●●●"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col cols="12" md="6">
            <b-form-group>
              <label for="name">Confirm Password</label>
              <b-form-input
                v-model="confirmPassword"
                type="text"
                id="confirmPassword"
                placeholder="●●●●●●●●"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <div class="px-2">
            <b-button
              variant="outline-primary"
              size="sm"
              @click.prevent="changePassword"
            >Change Password</b-button>
          </div>
        </b-row>
        <template slot="footer">
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import EditUser from "./editUser";
import axios from "axios";
export default {
  data() {
    return {
      user: null,
      appLoading: false,
      ServerError: false,
      oldPassword: null,
      newPassword: null,
      confirmPassword: null,
      msg: null
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    changePassword() {
      if (!this.oldPassword || !this.newPassword || !this.confirmPassword) {
        this.msg = "Please Provide all details";
        return;
      }
      if (this.newPassword != this.confirmPassword) {
        this.msg = "Passwords Not Matching";
        return;
      }
      this.appLoading = true;
      var data = {};
      data["id"] = this.user._id;
      data["name"] = this.user.name;
      data["oldpassword"] = this.oldPassword;
      data["password"] = this.newPassword;
      axios({
        method: "POST",
        url: "/user/completeprofile",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: data
      })
        .then(response => {
          this.appLoading = false;
          if (response.data.status) this.$router.go(-1);
          else this.msg = response.data.msg;
        })
        .catch(e => {
          this.ServerError = true;
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.user = response.data.data;
        })
        .catch(e => {
          this.ServerError = true;
        });
    }
  }
};
</script>